import { gql } from '@apollo/client/core';

export const RetrievePartner = gql`
  query ($data: PartnerWhereUniqueInput!) {
    partner(where: $data) {
      id
      BillingAccounts {
        id
      }
      Contracts {
        id
        modelType
        partnerType
      }
    }
  }
`;
